<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>线索私海</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" style="width:150px" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="联系电话">
                    <el-input v-model="listQuery.tel" type="number" style="width:180px" placeholder="请输入联系电话" clearable></el-input>
                </el-form-item>

                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" style="width:150px" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>

                <el-form-item label="线索状态">
                    <el-select v-model="listQuery.state" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item,index) in clueState" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="求职意向">
                    <el-select v-model="listQuery.joinDemand" clearable placeholder="请选择服务类型" filterable>
                        <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <!-- <el-button v-per="'shxiansuoluru'"  icon="el-icon-plus" type="primary" plan @click="handleCreate">录入线索</el-button> -->
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <!-- <el-table-column prop="clueNo" label="线索编号"></el-table-column> -->
                <el-table-column prop="clueNo" label="线索编号"></el-table-column>
                <el-table-column prop="workerName" label="服务者姓名"></el-table-column>
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="idCard" label="服务者身份证" width="150"></el-table-column>
                <el-table-column prop="tel" label="服务者电话">
                    <template slot-scope="scope">
                        <phoneTag :phone="scope.row.tel" />
                    </template>
                </el-table-column>
                <el-table-column prop="joinDemand" label="求职意向">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state==3?'success':''">{{getqzyx(scope.row.joinDemand)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="线索状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state==3?'success':''">{{clueState[scope.row.state]}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="sourceRelationName" label="线索来源"></el-table-column>
                <el-table-column prop="workerBelongName" label="服务者归属"></el-table-column>
                <!-- <el-table-column prop="state" label="关联工单">
                    <template slot-scope="scope">
                        {{scope.row.ticket.ticketSn}}
                    </template>
                </el-table-column> -->
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="240">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row)">详细</el-button>
                        <el-button type="text" v-per="'addcluecomment'"  v-if="scope.row.state!=3&&scope.row.state!=4" icon="el-icon-edit" @click="handleFollow(scope.row)">添加跟进记录</el-button>
                        <el-button type="text"  v-per="'xiansuoliuzhuan'" v-if="scope.row.state!=3&&scope.row.state!=4" icon="el-icon-s-promotion" @click="toclueUpgrateForm(scope.row)">流转</el-button>
                        <el-button type="text"  v-per="'xiansuoliushi'" v-if="scope.row.state!=3&&scope.row.state!=4" icon="el-icon-close" @click="handleLoss(scope.row)">流失</el-button>
                        <el-button type="text"  v-per="'xiansuoyaoyue'" v-if="scope.row.state!=3&&scope.row.state!=4" icon="el-icon-key" @click="handleOffice(scope.row)">邀约</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>
 

        <!-- 线索跟进 -->
        <el-dialog title="线索跟进" :visible.sync="showFollowForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="followForm" ref="followForm" :rules="rules_Follow">
                <el-form-item label="跟进内容" prop="comment">
                    <el-input type="textarea" rows="6" v-model="followForm.comment" placeholder="请输入跟进内容" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showFollowForm = false">关闭</el-button>
                <el-button type="primary" @click="saveFollow">保存</el-button>
            </span>
        </el-dialog>

        <!-- 线索流失 -->
        <!-- <el-dialog title="线索流失" :visible.sync="showLossForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="lossForm" ref="lossForm" :rules="rules_Loss">
                <el-form-item label="流失备注" prop="comment">
                    <el-input type="textarea" rows="6" v-model="lossForm.comment" placeholder="请输入流失备注" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showLossForm = false">关闭</el-button>
                <el-button type="primary" @click="saveLoss">保存</el-button>
            </span>
        </el-dialog> -->

        <!-- 线索详情 -->
        <el-dialog title="线索详情" :visible.sync="showClueDetailForm" width="900px" :close-on-click-modal="false" center>
            <clueDetail :ticketId="clueDetailForm.ticketId" :clueId="clueDetailForm.clueId" v-on:onCloseDetailDialogVisible="handleCloseDetail" ref="clueDetailRef" />
        </el-dialog>

        <!-- 服务者上线 -->
        <el-dialog title="邀约" :visible.sync="showOfficeForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="officeForm" ref="officeForm" :rules="rules_Office">

                <el-form-item label="姓名" prop="workerName">
                    <el-input type="text" v-model="officeForm.workerName" maxlength="11" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>

                <el-form-item label="身份证" prop="idCard">
                    <el-input type="text" v-model="officeForm.idCard" maxlength="18" placeholder="请输入身份证" clearable></el-input>
                </el-form-item>

                <el-form-item label="手机号" prop="tel">
                    <el-input type="text" v-model="officeForm.tel" maxlength="11" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>

                <el-form-item label="上线类型" prop="workerType">
                    <el-select v-model="officeForm.workerType" style="width:100%" clearable placeholder="请选择上线类型" filterable>
                        <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="城市" prop="cityId">
                    <el-select v-model="officeForm.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驿站" prop="postStationId">
                    <el-select v-model="officeForm.postStationId" clearable placeholder="请选择驿站" filterable>
                        <template v-for="(item,index) in postStationList">
                            <el-option :key="index" v-if="item.cityId==officeForm.cityId" :label="item.postStationName" :value="item.id+''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务站" prop="stationId">
                    <el-select v-model="officeForm.stationId" clearable placeholder="请选择服务站" filterable>
                        <template v-for="(item,index) in allStationList">
                            <el-option :key="index" v-if="item.postStationId==officeForm.postStationId" :label="item.stationName" :value="item.id+''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注" prop="comment">
                    <el-input type="textarea" rows="5" v-model="officeForm.comment" placeholder="请输入上线备注" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showOfficeForm = false">关闭</el-button>
                <el-button type="primary" @click="saveOffice">保存</el-button>
            </span>
        </el-dialog>

        <!--线索流失 -->
        <leaveLossForm ref="leaveLossFormRef" />
        <!--线索流转 -->
        <clueUpgrateForm ref="clueUpgrateFormRef" />
           <!--新增线索 -->
        <workerClueAddForm ref="workerClueAddFormRef" />
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import clueDetail from "@/components/workercrm/clueDetail.vue";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import leaveLossForm from "@/components/workercrm/compent/leaveLossForm.vue";
import clueUpgrateForm from "@/components/workercrm/compent/clueUpgrateForm.vue";
import phoneTag from "@/components/workercrm/compent/phoneTag.vue";
import workerClueAddForm from "@/components/workercrm/compent/workerClueAddForm.vue";
import { validateIdNo,validateIdNotmust } from "@/script/validator";
let vm;
export default {
    components: {
        Pagination,
        clueDetail,
        leaveLossForm,
        clueUpgrateForm,
        phoneTag,
        workerClueAddForm
    },
    filters: {
        filterWorkerType(type) {
            if (type == 1) return "保洁";
            if (type == 2) return "保姆";
            if (type == 3) return "品类";
        },
    },
    data() {
        return {
            clueState: {
                1: "待分配",
                2: "跟进中",
                3: "跟进成功",
                4: "跟进失败",
                5: "上线失败",
                6: "跟单失败",
                7: "培训失败",
                8: "上线成功",
            },
            workTypes: [
                { value: 1, label: "保洁" },
                { value: 2, label: "保姆" },
                { value: 3, label: "品类" },
            ],
            skillGroups: [],
            supplierList: [],
            listData: [],
            cityList: [],
            postStationList: [],
            allStationList: [],

            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                cityId: "",
                tel: "",
                workerName: "",
                joinDemand: "",
                handlerId: globalData.userInfo.id,
                state: null,
            },
           
            showFollowForm: false, //跟进
            followForm: {
                clueId: "",
                comment: "",
            },
            rules_Follow: {
                comment: [
                    {
                        required: true,
                        message: "请输入跟进内容",
                        trigger: "change",
                    },
                ],
            },
            showUpgrateForm: false, //升级流转

            showLossForm: false, //流失
            lossForm: {
                clueId: "",
                comment: "",
                skillGroupId: "",
                userId: "",
            },
            rules_Loss: {
                comment: [
                    {
                        required: true,
                        message: "请输入跟进内容",
                        trigger: "change",
                    },
                ],
            },
            showClueDetailForm: false,
            clueDetailForm: {
                ticketId: "",
                clueId: "",
            },
            showOfficeForm: false,
            officeForm: {},
            rules_Office: {
                idCard: [
                    // {
                    //     required: true,
                    //     message: "请填写身份证号码",
                    //     trigger: "blur",
                    // },
                    {
                        validator: validateIdNotmust,
                        message: "身份证号码格式不对",
                        trigger: "blur",
                    },
                ],
                workerType: [
                    {
                        required: true,
                        message: "请选择上线类型",
                        trigger: "change",
                    },
                ],
                cityId: [
                    {
                        required: true,
                        message: "请选择城市",
                        trigger: "change",
                    },
                ],
                postStationId: [
                    {
                        required: true,
                        message: "请选择驿站",
                        trigger: "change",
                    },
                ],
                stationId: [
                    {
                        required: true,
                        message: "请选择服务站",
                        trigger: "change",
                    },
                ],
                workerName: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur",
                    },
                ],
            },
        };
    },

    created() {
        this.getAllCity();
        this.getAllPostStation(); //驿站
        this.getAllStationList();

        this.getSupplierList();
        this.querySearch();
    },
    methods: {
        toclueUpgrateForm(row) {
            //线索流转
            this.$refs.clueUpgrateFormRef.clueUpgrateForm("流转", row, null);
        },
        handleCreate() {
             this.$refs.workerClueAddFormRef.showAddWorkerClue(2);
        },
        handleFollow(row) {
            //跟进
            this.showFollowForm = true;
            this.followForm = {
                clueId: row.id,
                comment: "",
                operId: globalData.userInfo.id,
                operName: globalData.userInfo.userName,
                // ticketId: row.ticket.id,
            };
        },
        saveFollow() {
            this.$refs["followForm"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosGetTicketRemark(this.followForm)
                        .then((res) => {
                            this.$message.success("操作成功");
                            this.showFollowForm = false;
                        });
                }
            });
        },

        handleLoss(row) {
            this.$refs.leaveLossFormRef.leaveLossClick(row, 2, 4);
        },
        saveLoss() {
            this.$refs["lossForm"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosGetClueLoss(this.lossForm)
                        .then((res) => {
                            this.$message.success("操作成功");
                            this.showLossForm = false;
                            this.querySearch();
                        });
                }
            });
        },
        handleOffice(row) {
            //上线
            this.showOfficeForm = true;
            this.officeForm = {
                clueId: row.id,
                cityId: row.cityId + "",
                postStationId: null,
                stationId: null,
                operId: globalData.userInfo.id,
                operName: globalData.userInfo.userName,
                workerName: row.workerName,
                idCard: row.idCard,
                tel: row.tel,
                comment: null,
            };
        },
        saveOffice() {
            console.log(this.officeForm);
            this.$refs["officeForm"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosGetTakeOffice(this.officeForm)
                        .then((res) => {
                            this.$message.success("上线成功");
                            this.showOfficeForm = false;
                            this.querySearch();
                        });
                }
            });
        },
        handleDetail(row) {
            this.$router.push({
                path: "/workermanager/empowermentTrain/clueDetail",
                query: {
                    // ticketId: row.ticket.id,
                    clueId: row.id,
                },
            });
        },
        handleCloseDetail() {
            this.showClueDetailForm = false;
        },
        saveCreate() {
            console.info(this.updateClue);
            this.$refs["updateClue"].validate((valid) => {
                if (valid) {
                    workercrmapi
                        .$axiosAddWorkerClue(this.updateClue)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.showUpdate = false;
                                this.querySearch();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                }
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            // this.listQuery.handleId = globalData.userInfo.id;
            this.listQuery.ofJz=globalData.company.id;
            workercrmapi.$axiosGetClueList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        }, 
        
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },

        getSupplierList() {
            //获取归属
            workercrmapi.$axiosGetSupplierList({ companyId: globalData.company.id }).then((res) => {
                this.supplierList = res.data.data;
            });
        },

        getAllPostStation() {
            workercrmapi.$axiosPostStationgetAllList().then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllStationList() {
            //服务站
            wmsApi.$axiosGetAllStationList().then((res) => {
                if (res.data.errno == 0) {
                    this.allStationList = res.data.data;
                }
            });
        },
        getqzyx(val) {
            if (val == null || val == "") {
                return;
            }
            //1保洁、2保姆、3品类
            return val
                .replace("1", "保洁")
                .replace("2", "保姆")
                .replace("3", "品类");
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>